import { RefObject, useEffect } from 'react';
import { useScroll } from '@ui/src';
import { useAppDispatch } from '@store';
import { useLazyGetCustomerLocksAuditLogsQuery } from '../../store/services/individual';
import { setLogsTakeCount } from '../../store/slices/security';

const useLogsList = ({
  scrollRef,
}: {
  scrollRef: RefObject<HTMLDivElement | null>;
}) => {
  const dispatch = useAppDispatch();

  const [getList, { isFetching, isLoading }] =
    useLazyGetCustomerLocksAuditLogsQuery();

  useScroll({
    element: scrollRef,
    requestInProgress: isFetching,
  });

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      const { offsetHeight } = scrollRef.current;

      if (offsetHeight) {
        const take = offsetHeight / 58;

        dispatch(setLogsTakeCount(Math.ceil(take + 3)));
      }
    }
  }, [scrollRef]);

  return {
    getList,
    isLoading,
    isFetching,
  };
};

export default useLogsList;
